// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"date-ranger-picker__blockCommon___2535p","formItem":"date-ranger-picker__formItem___16gY0"};